import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
 PeopleAltOutlined,
} from "@mui/icons-material";
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import userService from "../../../components/Services/user.service";
import { useDispatch } from "react-redux";
import { disableButton, enableButton } from "../../../store/ButtonFlag/actions";
import CustomConfirmBox from "../../DashBoard/customConfirmBox";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";

const CompanyAdminSideBar = ({ usersData,userSelection,getAllCompanyAdminUsers }) => {
 const [open, setOpen] = useState(true);
 const [selectedIndex, setSelectedIndex] = React.useState(0);
 const [deleteUserOpen, setDeleteUserOpen] = useState(false);
 const [selectedUserItem,setSelectedUserItem] = useState();

const dispatch = useDispatch();

 const handleClick = () => {
  setOpen(!open);
 };

 const handleListItemClick = (event, index) => {
   setSelectedIndex(index);
   userSelection(index);
 };

const handleDelete = (e,item) => {
  e?.stopPropagation();
  setSelectedUserItem(item);
  setDeleteUserOpen(!deleteUserOpen);
 };
 const handleClose = () => {
  disableButton()(dispatch);
  userService.deleteUserFromCompanyAdmin(selectedUserItem?.id)
   .then((response) => {
    if (response?.data?.code === 200) {
     setDeleteUserOpen(false);
     toast.success(response?.data?.message, toastProperties);
     getAllCompanyAdminUsers()
     enableButton()(dispatch);
    } else if (response?.data?.code !== 200) {
     enableButton()(dispatch);
    }
   })
   .catch((error) => {
    console.error("Api call Error :", error);
    enableButton()(dispatch);
   });
 };
 return (
  <>
  {deleteUserOpen && (
         <CustomConfirmBox
          title="Delete User"
          message={`Do you want to Delete user ${selectedUserItem?.userName} ?`}
          open={deleteUserOpen}
          handleClose={handleClose}
          handleCloseNo={handleDelete}
         />
        )}
  <div>
   <aside className="sidebar">
    <List
     sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
     component="nav"
     aria-labelledby="nested-list-subheader"
    >
     <ListItemButton onClick={handleClick}>
      <ListItemIcon>
       <PeopleAltOutlined />
      </ListItemIcon>
      <ListItemText primary="Users" />
      {open ? <ExpandLess /> : <ExpandMore />}
     </ListItemButton>
     <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
       {usersData?.map((item,i)=>(
        <ListItemButton selected={selectedIndex === i}
        onClick={(event) => handleListItemClick(event,i)} key={i} sx={{ pl: 4 }}>
        <ListItemText primary={item?.userName?.charAt(0)?.toUpperCase() + item?.userName?.slice(1)?.toLowerCase()} />
        {!item?.userCompanies?.[0]?.companyRoles?.some(
         (item) => (item.role?.role === "COMPANY_ADMIN" || item.role?.role === "TRADER" )
        ) && <DeleteTwoToneIcon onClick={(e)=>handleDelete(e,item)} />}
       </ListItemButton>
       ))}
      </List>
     </Collapse>
    </List>
   </aside>
  </div>
  </>
 );
};

export default CompanyAdminSideBar;
